/**
 * @generated SignedSource<<4f8400fc7f13e29fd684eed06a0f3897>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskBrowseByTopic_viewer$data = {
  readonly zendeskSupport: {
    readonly categories: ReadonlyArray<{
      readonly displayName: string | null;
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskBrowseByTopic_viewer";
};
export type GetHelpZendeskBrowseByTopic_viewer$key = {
  readonly " $data"?: GetHelpZendeskBrowseByTopic_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskBrowseByTopic_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskBrowseByTopic_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "Contact1stdibsZendeskSupport",
      "kind": "LinkedField",
      "name": "zendeskSupport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZendeskSupportCategory",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "75b2576c78233d6b3cac4dad58993f37";

export default node;
